exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".qmodii .theme--light.v-counter{color:rgba(0,0,0,.54)}.qmodii .theme--dark.v-counter{color:hsla(0,0%,100%,.7)}.qmodii .v-counter{flex:0 1 auto;font-size:12px;min-height:12px;line-height:1}", ""]);

// exports
